module.exports = __webpack_public_path__ + "img/product-preview-51.549152a.png";